import React, { useEffect, useState } from 'react'
import { Badge } from 'antd'
import { useSelector } from 'react-redux'

import { useInventory } from '../../modules'

import Routing, { MenuItem, SideMenu } from '../../components/reusable/routing'

import Dashboard from './dashboard'
import Employees from './employees'
import { components } from 'react-select'

let menu = [
    {
        path: '',
        title: 'Dashboard',
        component: Dashboard
    },
    {
        path: 'employees',
        title: 'Employees',
        submenu: [
            {
                path: 'all',
                title: 'All Employees',
                component: Employees
            },
            {
                path: 'attendance',
                title: 'Attendance'
            },
            {
                path: 'leaves',
                title: 'Leaves'
            },
            {
                path: 'holidays',
                title: 'Holidays'
            },
            {
                path: 'departments',
                title: 'Departments'
            },
            {
                path: 'designations',
                title: 'Designations'
            },
            {
                path: 'shifts-schedules',
                title: 'Shifts & Schedules'
            },
            {
                path: 'promotions',
                title: 'Promotions'
            },
            {
                path: 'overtime',
                title: 'Overtime'
            },
            {
                path: 'resignations',
                title: 'Resignations'
            },
            {
                path: 'terminations',
                title: 'Terminations'
            }
        ]
    },
    {
        path: 'jobs',
        title: 'Jobs',
        submenu: [
            {
                path: '',
                title: 'Jobs'
            },
            {
                path: 'applications',
                title: 'Applications'
            },
            {
                path: 'shortlisting',
                title: 'Shortlistings'
            },
            {
                path: 'interviews',
                title: 'Interviews'
            },
            {
                path: 'departments',
                title: 'Departments'
            }
        ]
    },
    {
        path: 'inventory',
        title: 'Inventory',
    },
    {
        path: 'parameters',
        title: 'Parameters'
    }
]

const storeName = "Human Resources"

const HR = () => {
    const [Inventory, store, requests] = useInventory(storeName)

    const { user } = useSelector(state => state.application)

    useEffect(() => {
        if (user.stores.some(st => st.name === storeName) || user?.issuperuser)
            menu[3] = {
                path: 'inventory',
                title: props => 
                    <Badge className='w-12' count={ requests }>
                        <MenuItem condition={ props?.condition }>Inventory</MenuItem>
                    </Badge>,
                component: ({ path }) => <Inventory path={ path } storeName={ storeName } />
            }
    }, [store, user])

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto flex flex-no-wrap max-h-full overflow-hidden">
            <div className="w-1/6 overflow-y-scroll">
                <p className="text-2xl font-semibold">Human Resources</p>
                <SideMenu namespace="human-resources" menu={ menu } />
            </div>
            <div className="w-5/6 overflow-y-scroll">
                <Routing namespace="human-resources" menu={ menu } />
            </div>
        </div>
    )
}

export default HR